var _path, _rect, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhoneSelector = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3863F0",
  d: "M8.013 2.667H19.32c.454 0 .666.552.407.926a6.002 6.002 0 0 0 2.763 9c.99.385 1.843 1.23 1.843 2.291v9.37c0 3.746-1.333 5.08-5.026 5.08H8.013C4.333 29.333 3 28 3 24.253V7.746C3 4 4.333 2.667 8.013 2.667"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 3,
  x: 9.667,
  y: 23,
  fill: "#fff",
  rx: 1.5
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 24.667,
  cy: 7,
  r: 5,
  fill: "#F56B57"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m24.665 8.842-.593-1.428a.6.6 0 0 0-.25-.26q.684-.207.685-.968 0-.45-.25-.793Q23.954 5 23.161 5h-1.495v3.842h.944V7.247h.159q.165 0 .217.041.059.042.117.184l.56 1.37zm-2.054-1.93v-1.57h.417q.25 0 .393.251.142.25.142.568t-.142.534a.45.45 0 0 1-.393.218zM25.917 6.036l-.259-.2h-.434v4.275l.936-.125V8.86q.283.058.56.058 1.277 0 1.277-1.578 0-1.58-1.286-1.579-.392 0-.794.276m.242 2.405V6.336q.168-.05.268-.05.643 0 .643 1.086t-.61 1.086q-.2 0-.3-.017"
})));
export default SvgPhoneSelector;